import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ActiveFiltersProps {
  filters: {
    type: string;
    value: string;
    label: string;
  }[];
  onRemove: (type: string, value: string) => void;
  onClearAll: () => void;
}

const ActiveFilters = ({ filters, onRemove, onClearAll }: ActiveFiltersProps) => {
  if (filters.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm font-semibold text-muted-foreground">Active Filters:</span>
      {filters.map((filter, index) => (
        <div
          key={`${filter.type}-${filter.value}-${index}`}
          className="flex items-center space-x-2 px-3 py-1.5 bg-primary/10 text-primary rounded-full border border-primary/20"
        >
          <span className="text-sm font-medium">{filter.label}</span>
          <button
            onClick={() => onRemove(filter.type, filter.value)}
            className="hover:bg-primary/20 rounded-full p-0.5 transition-colors duration-200"
            aria-label={`Remove ${filter.label} filter`}
          >
            <Icon name="XMarkIcon" size={14} variant="outline" />
          </button>
        </div>
      ))}
      <button
        onClick={onClearAll}
        className="text-sm text-error hover:text-error/80 font-semibold underline"
      >
        Clear All
      </button>
    </div>
  );
};

export default ActiveFilters;